import { Button } from '~/components/button'
import type { ViewProps } from 'react-native'
import * as Comp from './coachmark-footer.styles'

type CoachMarkFooterProps = ViewProps & {
  currentStep: number
  totalStep: number
  onPrevious: () => void
  onNext: () => void
}

export function CoachMarkFooter({
  currentStep,
  totalStep,
  onPrevious,
  onNext,
  testID,
  ...viewProps
}: CoachMarkFooterProps) {
  const validatedCurrentStep = Math.max(1, Math.min(99, currentStep))
  const validatedTotalStep = Math.max(
    validatedCurrentStep,
    Math.min(99, totalStep)
  )

  const isLastStep = validatedCurrentStep === validatedTotalStep

  return (
    <Comp.Container testID={testID} {...viewProps}>
      <Comp.StepsContainer>
        <Comp.StepsText>{`${validatedCurrentStep}/${validatedTotalStep}`}</Comp.StepsText>
      </Comp.StepsContainer>

      <Comp.ButtonsContainer>
        <Button.Root
          variant="neutral-tertiary"
          size="ml"
          onPress={onPrevious}
          testID="coachmark-previous-button"
        >
          <Button.Label>
            {validatedCurrentStep > 1 ? 'Anterior' : 'Pular'}
          </Button.Label>
        </Button.Root>
        <Button.Root
          variant="neutral-secondary"
          size="ml"
          onPress={onNext}
          testID="coachmark-next-button"
        >
          <Button.Label>{isLastStep ? 'Concluir' : 'Próximo'}</Button.Label>
        </Button.Root>
      </Comp.ButtonsContainer>
    </Comp.Container>
  )
}
